import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// The design system loads before any component's CSS: a component stylesheet has
// to be able to override the base, and CSS order follows the import graph.
// **Inter is served from the site itself**, never from Google Fonts: a font
// fetched from Google is a request from every visitor's browser to Google, and
// the site talks to Cloudflare, Supabase and TMDB and nobody else (the Privacy
// page says so). The three weights the design uses — 400 regular, 500 headings,
// 600 spare — each split by alphabet, so a browser fetches only what a page
// needs.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import './styles/tokens.css';
import './styles/base.css';
import { App } from './App.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
